module.exports = __webpack_public_path__ + "img/405.7bd3ced8.svg";